import { Mark, InputRule } from '@tiptap/core';

export interface InternalLinkOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    internalLink: {
      setInternalLink: (pageId: string, pageTitle: string) => ReturnType;
      toggleInternalLink: (pageId: string, pageTitle: string) => ReturnType;
      unsetInternalLink: () => ReturnType;
    };
  }
}

export const InternalLink = Mark.create<InternalLinkOptions>({
  name: 'internalLink',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      pageId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-page-id'),
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.pageId) {
            return {};
          }
          return { 'data-page-id': attributes.pageId };
        },
      },
      pageTitle: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-page-title'),
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.pageTitle) {
            return {};
          }
          return { 'data-page-title': attributes.pageTitle };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-page-id]',
        getAttrs: (element: HTMLElement) => ({
          pageId: element.getAttribute('data-page-id'),
          pageTitle: element.getAttribute('data-page-title'),
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['span', { ...(this as any).options.HTMLAttributes, ...HTMLAttributes, class: 'internal-link' }, 0];
  },

  addCommands() {
    return {
      setInternalLink: (pageId, pageTitle) => ({ chain }) => {
        return chain().setMark('internalLink', { pageId, pageTitle }).run();
      },
      toggleInternalLink: (pageId, pageTitle) => ({ chain }) => {
        return chain().toggleMark('internalLink', { pageId, pageTitle }).run();
      },
      unsetInternalLink: () => ({ chain }) => {
        return chain().unsetMark('internalLink').run();
      },
    };
  },
  
  addInputRules() {
    return [
      new InputRule({
        find: /(\S*)\[\[([^\]]+)\]\]\s$/,
        handler: ({ state, match, range }) => {
          const { tr } = state;
          const [fullMatch, beforeText, pageTitle] = match;
          tr.delete(range.from, range.to);
          tr.insertText(beforeText, range.from);
        },
      }),
    ];
  },
});
